<script lang="ts" setup>
import { ref, computed, onMounted, watch, reactive } from 'vue';
import { getSliderImages, getSliderVideos, videoUrl, getAvatar, videoPreview } from '../../../utils';
import { usePerformerStore } from '@/stores/performer';
import { useUserStore } from '@/stores/user';
import { useMediaStore } from '@/stores/media';
import { useAlertsStore } from '@/stores/alerts';
import { useRouter } from 'vue-router';
import { getStaticImages, isPaidMedia } from '@/utils';
import config from '../../../config';

const props = defineProps<{ 
    userId: number; 
    performer: any; 
    medias: any;
    current: number
    fullscreen: boolean;
}>();

const { payContent } = useUserStore();
const emit = defineEmits(['close']);
const performerStore = usePerformerStore();
const mediaStore = useMediaStore();
const userStore = useUserStore();
const { openMessage } = useAlertsStore();
const { getCurrentMedia } = useMediaStore();
const noCredits = ref(false);
const router = useRouter();
let mediasRef = ref([]);

let currentSelected = ref(0);
let touchStart = ref(0);
let isModal = ref(false);

onMounted(() => {
    currentSelected.value = props.current === 0 ? 0 : props.medias.findIndex((p: any) => p.id === props.current);
});

const mobile = computed(() => {
    return props.fullscreen && userStore.mobile;
});

const isLast = computed(() => {
    return currentSelected.value === props.medias.length - 1;
});

const isFirst = computed(() => {
    return currentSelected.value === 0;
});

const hasMedia = computed(() => {
    return props.medias ? props.medias.length > 0 : false;
});

function getPerformer(item: any){
    return props.performer ? props.performer : item.performer;
}

function getVideoPlaceholder(video: any){
    return {active: video.hasOwnProperty('namePreview'), url: video.hasOwnProperty('namePreview') ? `${config.FullApiUrl}video/${getPerformer(video).id}/medium/${video.namePreview}`: getStaticImages('vidplaceholder', 'jpg')};
}

const close = () => {
    emit('close');
};

function isActiveFromList(id: any){
    return currentSelected.value === props.medias.findIndex((p: any) => p.id === id);
}

function pauseVideos() {
    if (mediasRef.value && Array.isArray(mediasRef.value)) {
        for (const videoElement of mediasRef.value as Array<HTMLVideoElement>) {
            videoElement.pause();
        }
    }
}

function next() {
    if (isLast.value) {
        return;
    }

    pauseVideos();

    isModal.value = false;
    currentSelected.value += 1;
}

function previous() {
    if (isFirst.value) {
        return;
    }

    pauseVideos();

    isModal.value = false;
    currentSelected.value -= 1;
}

async function buyContent(media: any) {
    const payloadPhoto = { serviceType: 'PHOTO', photoId: media.id };
    const payloadVideo = { serviceType: 'MEDIA', mediaId: media.id };
    const payload = media.type === 'video' ? payloadVideo : payloadPhoto;
    const error = await payContent(props.userId, getPerformer(media).id, payload);

    if (error) {
        noCredits.value = true
        return;
    }

    openMessage({
        content: media.type === 'video' ? 'modals.alerts.successPurchaseMedia' : 'modals.alerts.successPurchasePhoto',
        class: 'success'
    });

    await mediaStore.setMedia(true);
    toggleModal();
}

function toggleModal() {
    isModal.value = !isModal.value;
    noCredits.value = false;
}

function onTouchStart(evt: TouchEvent){
    touchStart.value = evt.touches[0].pageX;
}

function onTouchEnd(evt: TouchEvent){
    const touchDifference = touchStart.value - evt.changedTouches[0].pageX;

    if(touchDifference > 75){
        next();
    } else if(touchDifference < -75){
        previous();
    }
}

document.onkeydown = onKeyPress;

function onKeyPress(evt: KeyboardEvent){
    if(evt.code === 'ArrowRight'){
        next();
    } else if(evt.code === 'ArrowLeft'){
        previous();
    } else if(evt.code === 'Escape'){
        close();
    }
}

watch(() => props.current, 
    (newValue, oldValue) => {
        currentSelected.value = props.current === 0 ? 0 : props.medias.findIndex((p: any) => p.id === props.current);
    }
);

</script>

<template src="./slider.html"></template>
<style lang="scss">
@import './slider.scss';
</style>
